<ng-container [ngSwitch]="type">
    <ng-container *ngSwitchCase="GspNumberType.GENERIC">
        <input
            #inputRef="ngModel"
            type="text"
            id="{{ id }}"
            class="gsp-form-input {{ inputClass }}"
            [ngClass]="inputNgClass"
            [name]="name"
            [placeholder]="placeholder"
            [autocomplete]="autoComplete"
            [title]="title"
            [(ngModel)]="value"
            (ngModelChange)="valueChange.emit(value)"
            (focus)="focusEvent.emit($event)"
            (blur)="blurEvent.emit($event)"
            (keyup)="keyupEvent.emit($event)"
            (keydown)="keydownEvent.emit($event)"
            [disabled]="disabled"
            [required]="required"
            [errorTooltip]="errorTooltipMsg"
            numeric
            [decimal]="decimalPlaces"
            [digitGroup]="digitGroup"
        />
    </ng-container>
    <ng-container *ngSwitchCase="GspNumberType.DECIMAL">
        <input
            #inputRef="ngModel"
            type="number"
            id="{{ id }}"
            class="gsp-form-input {{ inputClass }}"
            [ngClass]="inputNgClass"
            [name]="name"
            [placeholder]="placeholder"
            [title]="title"
            [(ngModel)]="value"
            (ngModelChange)="valueChange.emit(value)"
            (focus)="focusEvent.emit($event)"
            (blur)="blurEvent.emit($event)"
            (keyup)="keyupEvent.emit($event)"
            (keydown)="keydownEvent.emit($event)"
            [disabled]="disabled"
            [readOnly]="readonly"
            [required]="required"
            [errorTooltip]="errorTooltipMsg"
            decimalValidate
            [min]="min"
            [max]="max"
        />
    </ng-container>
    <ng-container *ngSwitchCase="GspNumberType.PORT">
        <input
            #inputRef="ngModel"
            type="number"
            id="{{ id }}"
            class="gsp-form-input {{ inputClass }}"
            [ngClass]="inputNgClass"
            [name]="name"
            [placeholder]="placeholder"
            [title]="title"
            [(ngModel)]="value"
            (ngModelChange)="valueChange.emit(value)"
            (focus)="focusEvent.emit($event)"
            (blur)="blurEvent.emit($event)"
            (keyup)="keyupEvent.emit($event)"
            (keydown)="keydownEvent.emit($event)"
            [disabled]="disabled"
            [readOnly]="readonly"
            [required]="required"
            [maxlength]="length"
            [errorTooltip]="errorTooltipMsg"
            portValidate
        />
    </ng-container>
</ng-container>
